import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import CarModal from '../../components/modals/CarModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Cars extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {name: ''};
    this.state = {redirect: false, cars: [], filteredCars: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate, profiles: []};
  }

  componentDidMount() {
    this.validateToken();
    this.getCars();
    this.getProfiles();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager or empleado"))
      this.setState({redirect: true});
  }

  getCars() {
    let url = `${Configuration.apiServer}/api/v1/cars`;
    if (Configuration.isInRol(localStorage.getItem('visitapp:rol'), "empleado")) {
      url = `${Configuration.apiServer}/api/v1/employee-cars`;
    }

    axios.get(url, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({cars: resp.data, filteredCars: resp.data});
    });
  }

  getProfiles() {
    axios.get(`${Configuration.apiServer}/api/v1/profiles`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({profiles: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/cars/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getCars();
    });
  }

  handleSearch(event) {
    const cars = this.state.cars.filter(car => {
      return car.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredCars: cars});
  }

  handleOpenModal(kind, record) {
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/cars`, {car: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getCars();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/cars/${this.state.current.id}`, {car: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getCars();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of cars
    const cars = this.state.filteredCars.map(car => {
      return (
        <Card
          style={{ width: '24%', margin: '10px 0px' }}
          actions={
            Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin") ? 
              [<a href={`/admin/cars/${car.id}`}><Icon type="eye" /></a>, <Icon type="edit" onClick={() => { this.handleOpenModal('edit', car) }} />]
            : null
          }
          key={car.id}
        >
          <Meta
            avatar={<Avatar icon="car" />}
            title={car.plate}
            description={<span className={`cursor text-${Configuration.getStatus(car.status).color}`} onClick={() => { this.handleStatus(car.id) }}>{Configuration.getStatus(car.status).text}</span>}
          />
          <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>{car.details}</p>
          <hr/> 
          <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}><Icon type="user" /> {car.profile.names}</p>
        </Card>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Autos</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            {cars}
          </div>
        </div>

        {Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin") ?
          <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />
        : null }

        <CarModal visible={this.state.modalVisible} title={"Nuevo auto"} current={this.state.current} profiles={this.state.profiles} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />
      </div>
    );
  }
}

export default Cars;



// WEBPACK FOOTER //
// ./src/pages/admin/Cars.js